module.exports = __webpack_public_path__ + "img/postback-step-3.ru.ad582786.jpg";